import { useState } from "react";
import { api } from "../lib/api";
import { ThumbsUp, Heart, Lightbulb, PartyPopper, HandHelping } from "lucide-react";

const REACTIONS = [
  { kind: "like", icon: ThumbsUp, color: "#00aaff", label: "Like" },
  { kind: "love", icon: Heart, color: "#ff6c8a", label: "Love" },
  { kind: "insightful", icon: Lightbulb, color: "#ffd166", label: "Insightful" },
  { kind: "celebrate", icon: PartyPopper, color: "#39ff14", label: "Celebrate" },
  { kind: "support", icon: HandHelping, color: "#a78bfa", label: "Support" },
];

export default function ReactionBar({ postId, count = 0, myReaction, onChange }) {
  const [active, setActive] = useState(myReaction || null);
  const [busy, setBusy] = useState(false);
  const [count_, setCount] = useState(count);

  const react = async (kind) => {
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/posts/${postId}/react`, { kind });
      const next = data.my_reaction;
      // Update count locally: add if was null and now set, subtract if was set and now null
      let delta = 0;
      if (active && !next) delta = -1;
      if (!active && next) delta = 1;
      setActive(next);
      setCount((c) => Math.max(0, c + delta));
      onChange?.(next);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid={`reactions-${postId}`}>
      {REACTIONS.map(({ kind, icon: Icon, color, label }) => {
        const isActive = active === kind;
        return (
          <button
            key={kind}
            onClick={() => react(kind)}
            disabled={busy}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border text-xs transition-all duration-200 ${
              isActive
                ? "border-transparent text-white"
                : "border-[rgba(0,170,255,0.18)] text-[#94a3b8] hover:text-white"
            }`}
            style={isActive ? { background: `${color}26`, borderColor: color, boxShadow: `0 0 12px ${color}55`, color } : {}}
            data-testid={`react-${kind}`}
            title={label}
          >
            <Icon size={14} />
            <span className="font-mono-tech text-[10px] uppercase tracking-wider">{label}</span>
          </button>
        );
      })}
      {count_ > 0 && (
        <span className="font-mono-tech text-[11px] text-[#94a3b8] ml-1">{count_}</span>
      )}
    </div>
  );
}
